"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EDITORIAL_CAROUSEL_SECTION_BUTTON = exports.EDITORIAL_CAROUSEL_SECTION = void 0;
const EDITORIAL_CAROUSEL_SECTION = exports.EDITORIAL_CAROUSEL_SECTION = 'editorial-carousel-section';
const EDITORIAL_CAROUSEL_SECTION_BUTTON = exports.EDITORIAL_CAROUSEL_SECTION_BUTTON = 'editorial-carousel-section-button';
